module.exports = __webpack_public_path__ + "static/media/Screenshot--songUpload.e94bf5d0.png";